import React from 'react';
import { Box, Typography, Checkbox } from '@material-ui/core';
import useStyles from './CheckboxGrid.styles';
import { IEditForm } from '../../types/interfaces/IEditForm';

const CheckboxGrid: React.FC<IEditForm> = ({ checkboxGrid, items, onChange, value, fieldName }) => {
  const styles = useStyles();

  if (!checkboxGrid) {
    throw new Error('define `checkboxGrid` in checkboxGrid field config');
  }
  if (!items) {
    throw new Error('define `items` in checkboxGrid field config');
  }
  if (!onChange) {
    throw new Error('define `onChange` in checkboxGrid field config');
  }

  return (
    <Box>
      <Box display="flex">
        <Box>
          <Box className={styles.row} />
          {items.map((item) => (
            <Box className={styles.row} key={item.fieldName}>
              <Typography variant="subtitle2">{item.label}</Typography>
            </Box>
          ))}
        </Box>
        {checkboxGrid.map((selectable) => (
          <Box className={styles.checkboxColumn} key={selectable.key}>
            <Typography variant="subtitle2" className={styles.row}>
              <Box fontWeight={600}>{selectable.label}</Box>
            </Typography>
            {items.map((item) => (
              <Box className={styles.row} key={item.fieldName}>
                <Checkbox
                  checked={value[item.fieldName][selectable.key]}
                  onClick={() =>
                    onChange(fieldName, {
                      ...value,
                      [item.fieldName]: {
                        ...value[item.fieldName],
                        [selectable.key]: !value[item.fieldName][selectable.key],
                      },
                    })
                  }
                />
              </Box>
            ))}
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default CheckboxGrid;
